import { Box, Modal, Typography } from '@mui/material'
import { Button } from 'components'

const ConfirmationModal = ({
  open,
  onClose,
  onConfirm,
  title = 'Confirm Action',
  message = 'Are you sure you want to proceed? This action cannot be undone.',
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  loading = false,
  loadingText = 'Processing...',
  confirmColor = '#ffc107',
  cancelColor = '#d3d3d3'
}) => (
  <Modal open={open} onClose={onClose} aria-labelledby="confirmation-modal">
    <Box
      sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        bgcolor: 'background.paper',
        borderRadius: 1,
        boxShadow: 24,
        p: 3
      }}
    >
      <Typography variant="h6" component="h2" gutterBottom>
        {title}
      </Typography>
      <Typography variant="body1" gutterBottom>
        {message}
      </Typography>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, mt: 3 }}>
        <Button
          text={cancelText}
          onClick={onClose}
          color="white"
          background_color={cancelColor}
          padding="0.5rem 1rem"
        />
        <Button
          text={loading ? loadingText : confirmText}
          color="white"
          onClick={onConfirm}
          disabled={loading}
          loading={loading}
          background_color={confirmColor}
          padding="0.5rem 1rem"
        />
      </Box>
    </Box>
  </Modal>
)

export default ConfirmationModal
